import { useParams } from 'react-router-dom';

import TimelineDetails from '@components/timelineDetails/TimelineDetails';
import { useAccount } from '@contexts/AccountProvider';
import useGetTimeline from '@hooks/queries/useGetTimeline';

const TimelineDetailsContainer = () => {
    const { accountId, timelineId, nextcursor } = useParams();
    const { isLoading: isLoadingAccounts } = useAccount();

    const { data, isError, isLoading } = useGetTimeline({
        accountId,
        nextCursor: nextcursor,
    });

    const found = data?.pages[0].items?.find(
        (element) => element.timestamp === atob(timelineId),
    );

    return (
        <TimelineDetails
            timelineItem={found}
            isLoading={isLoading || isLoadingAccounts}
            isError={isError}
        />
    );
};

export default TimelineDetailsContainer;
